import { useQuery } from '@tanstack/react-query';
import { get } from 'lodash';

import { HkdBookPolicyAPI } from 'apis/hkdBookPolicy';

export const HKD_BOOK_POLICY_QUERY_KEY = ['hkd-books', 'policy'];

export const useHkdBookPolicyQuery = (options = {}) => {
  const query = useQuery({
    queryKey: HKD_BOOK_POLICY_QUERY_KEY,
    queryFn: HkdBookPolicyAPI.getHkdBookPolicy,
    ...options,
  });

  return {
    ...query,
    policy: get(query.data, 'data', {}),
    loading: query.isLoading,
  };
};

export const usePeriodPresetsQuery = (year, options = {}) => {
  const query = useQuery({
    queryKey: ['hkd-books', 'period-presets', year],
    queryFn: () => HkdBookPolicyAPI.getPeriodPresets(year),
    ...options,
  });

  return {
    ...query,
    presets: get(query.data, 'data', []),
    loading: query.isLoading,
  };
};
